<div *ngIf="isAlta && tableA" class="table-a-banner">
  <span class="table-a-banner__label">Table A:</span>
  <span class="table-a-banner__value">{{ tableA }}</span>
</div>
<div class="info-table-item">
  <ng-container *ngIf="showStatus">
    <p class="status --completed">Completed</p>
  </ng-container>
  <div class="address" *ngIf="showSite">
    <p class="address__site">#{{ site }}</p>
    <div class="address__address">
      <span
        class="material-icons address-pointer"
        [ngStyle]="
          data?.site?.specialSiteCondition
            ? { color: 'var(--error)', fontWeight: 'bold' }
            : { color: 'var(--text)' }
        "
        matTooltip="Click here for more info on Site Requirements."
        matTooltipPosition="above"
    matTooltipClass="site-req-tooltip"
        [matTooltipDisabled]="!data?.site?.specialSiteCondition"
        (click)="toggleMapModal(type, id)"
        >info_outline</span
      >
      <div class="address-pointer" [routerLink]="['/', type, id]">
        <p>
          <span *ngIf="address.streetAddress"
            >{{ address.streetAddress }}<br /></span
          >{{ address.cityStateZip }}
        </p>
      </div>
    </div>
  </div>
  <p *ngIf="showAcreage" class="table-row-font">{{ acreage }}</p>
  <div
    *ngIf="showSiteType"
    class="address-pointer"
    [routerLink]="['/', type, id]"
  >
    <div class="service-type">
      <p>{{ siteSubType ? siteType + " - " + siteSubType : siteType }}</p>
    </div>
  </div>
  <p *ngIf="showLandUse" class="table-row-font">
    {{ landUse || "Not Provided" }}
  </p>

  <div
    *ngIf="showSiteRequirements"
    class="site-req"
    [ngClass]="{ 'site-req--active': data?.site?.specialSiteCondition || (data?.site?.tableAChanges && (data?.site?.tableAChanges?.itemsAdded || data?.site?.tableAChanges?.itemsRemoved)) }"
    [matTooltip]="getFullSiteReqTooltip()"
    [matTooltipDisabled]="!data?.site?.specialSiteCondition && !(data?.site?.tableAChanges?.itemsAdded || data?.site?.tableAChanges?.itemsRemoved)"
    matTooltipPosition="above"
    matTooltipClass="site-req-tooltip"
  >
    <ng-container *ngIf="data?.site?.tableAChanges && (data?.site?.tableAChanges?.itemsAdded || data?.site?.tableAChanges?.itemsRemoved)">
      <div class="site-req__table-a">
        <p class="table-row-font"><strong>Table A:</strong></p>
        <p *ngIf="data?.site?.tableAChanges?.itemsAdded" class="table-row-font site-req__added">+ {{ data.site.tableAChanges.itemsAdded }}</p>
        <p *ngIf="data?.site?.tableAChanges?.itemsRemoved" class="table-row-font site-req__removed">− {{ data.site.tableAChanges.itemsRemoved }}</p>
      </div>
      <hr *ngIf="data?.site?.specialSiteCondition" class="site-req__divider" />
    </ng-container>
    <p *ngIf="data?.site?.specialSiteCondition" class="table-row-font">{{
      data?.site?.specialSiteCondition?.length > 100
        ? (data?.site?.specialSiteCondition | slice:0:100) + '...'
        : data?.site?.specialSiteCondition
    }}</p>
  </div>

  <div class="info-table-item__docs-info">
    <span class="info-table-item__icon-text" *ngIf="!isAlta">
      <div class="documents" (click)="toggleOpenExpensesModal()">
        <span class="material-icons">wallet</span>
      </div>
      <span class="documents-label">Expenses</span>
    </span>
    <span class="info-table-item__icon-text">
      <div class="documents" (click)="toggleOpenDocumentsModal()">
        <span class="material-icons">upload</span>
        <div *ngIf="documents?.length > 0" class="documents__number">
          {{ documents?.length }}
        </div>
      </div>
      <span class="documents-label">Documents</span>
    </span>
    <span class="info-table-item__icon-text">
      <div class="documents" (click)="toggleNotesModal()">
        <span class="material-icons">notes</span>
      </div>
      <span class="documents-label">Notes</span>
    </span>
  </div>
  <ng-container *ngIf="showActions">
    <div class="proposals-actions">
      <div class="turn-time">
        <p>Due Date</p>
        <p>{{ deliveryDate | date : "MM/dd/yyyy" : locale }}</p>
      </div>
      <ng-template #deliverDate>
        <div class="turn-time">
          <p>Due Date</p>
          <p>{{ deliveryDate | date : "MM/dd/yyyy" : locale }}</p>
        </div>
      </ng-template>
      <div class="bid-amount">
        <p>Bid Amount</p>
        <p>${{ bidAmount }}</p>
      </div>
    </div>
  </ng-container>
  <div class="info-table-button address-pointer" [routerLink]="['/', type, id]">
    <span class="material-icons">visibility</span>
    <p>View</p>
  </div>

  <mapmodal-dialog
    [active]="mapActive"
    [siteType]="selectedSiteType"
    [siteId]="selectedSiteId"
    [data]="data"
    [address]="address"
    (modalClosed)="toggleMapModal(type, id)"
    [ngClass]="{ 'mapmodal-dialog--active': mapActive }"
  ></mapmodal-dialog>
</div>

<documents-dialog
  [data]="data"
  [active]="documentsActive"
  [documents]="documents"
  [siteType]="siteType"
  [siteSubType]="siteSubType"
  [address]="address"
  (modalClosed)="toggleCloseDocumentsModal()"
  (update)="updateDocuments($event)"
  [ngClass]="{ 'documents-dialog--active': documentsActive }"
></documents-dialog>

<notes-dialog
  [active]="notesActive"
  [siteType]="siteType"
  [siteSubType]="siteSubType"
  [address]="address"
  (modalClosed)="toggleNotesModal()"
  [ngClass]="{ 'documents-dialog--active': notesActive }"
  [bidNotes]="bidNotes"
  [data]="data"
></notes-dialog>

<comments-dialog
  [active]="commentsActive"
  [documents]="documents"
  [siteType]="siteType"
  [address]="address"
  (modalClosed)="toggleCommentsModal()"
  [ngClass]="{ 'documents-dialog--active': commentsActive }"
></comments-dialog>

<expenses-dialog
  [data]="data"
  [active]="expensesActive"
  [siteType]="siteType"
  [siteSubType]="siteSubType"
  [address]="address"
  (modalClosed)="toggleCloseExpensesModal()"
  [ngClass]="{ 'documents-dialog--active': expensesActive }"
/>
